/**
 * @description utility method to check if field is required or not.
 * @param {array} validationObj array that contains all validation rules for a particular field.
 * @category Utils
 */
import { GafOktaManager } from "../auth/gaf-okta-auth";
import { fetchAPI } from "./service";
import * as API from "../../config.json";
import {   
    getCustomerIDFromStore,
    getContractorIDFromStore,
    getQueryString,
    getPersistData
} from "../utils/utils";

import AppTracking from "../AppTracking";
import { store } from "../store";
import { config } from "process";

const checkRequired = (validationObj) => {
    let isRequired = false;
    for (let i = 0; i < validationObj[0].value.length; i++) {
        if (validationObj[0].value[i].validationType === "required") {
            isRequired = true;
        }
    }
    return isRequired;
};
/**
 * @description utility method to return error object
 * @param {object} errorObject { error: false, errorMessage: [] }
 * @param {string} message error message corresponding to appropriate error type
 * @category Utils
 */
let isApicall= false;
 const validateOwnerEmail =async (ownerEmail) => {
    try {
     let url = API["CONFIG"].baseUrl + "Contractor/OwnerEmailVerification/"+ownerEmail;    
     const state = store.getState();
     const persistData = getPersistData();
     const contractorId = decodeURIComponent(getQueryString("contractorId", url) ||
     (state.adminData.contractorSelection && state.adminData.contractorSelection.contractorId) ||
     (persistData && persistData.contractorId) ||
     (config && config["contractorId"]));
     const customerId = decodeURIComponent(getQueryString("customerID", url) || getCustomerIDFromStore(false)); 
     const isAdmin = (state.adminData.userInfo && state.adminData.userInfo.isAdmin) || false;
     const isTm = (state.adminData.userInfo && state.adminData.userInfo.isTm) || false;
     if (contractorId && (isAdmin || isTm)){
            const endpoint = {
                url,
                method: 'GET'
            };
            const result = await fetchAPI(endpoint);
            return result.data;
     }
     if (customerId && !isAdmin && !isTm){
        const endpoint = {
            url,
            method: 'GET'
        };
        const result = await fetchAPI(endpoint);
        return result.data;
     }
      
    } catch (e) {  
     console.log(" error ", e)
     return false;
    }
  };
const setValidationMessage = (errorObject, message) => {
    errorObject.error = true;
    errorObject.errorMessage.push(message);
    return errorObject;
};

/**
 * @description utility method to validate form fields.
 * @param {string} value user entered value.
 * @param {string} fieldName form field name.
 * @param {string} family structure type the field belongs to.
 * @param {array} errorSchema error schema object.
 * @category Utils
 */
let isvalidEmail= false;

export const validationCheck = (value, fieldName, family, errorSchema) => {
        let error = { error: false, errorMessage: [] };
     let validationObj =
        errorSchema &&
        errorSchema.length &&
        errorSchema.filter((key) =>
            key.parentDependency ? key.key === fieldName && key.parentDependency === family : key.key === fieldName
        );
         
    const conditionalValidation =
        validationObj &&
        validationObj[0] &&
        validationObj[0].value.filter((val) => val.validationType === "conditional");
    const today = new Date();
    if (validationObj && validationObj.length > 0) {
        for (let i = 0; i < validationObj[0].value.length; i++) {
            if (conditionalValidation.length > 0 && validationObj[0].value[i].validationType === "conditional") {
                let dataValidatorValue = [];
                try {
                    dataValidatorValue = JSON.parse(conditionalValidation[0].value);
                } catch (e) {
                    dataValidatorValue = [];
                }
                if (dataValidatorValue && dataValidatorValue.length && value === dataValidatorValue[0].value) {
                    error = setValidationMessage(error, validationObj[0].value[i].message);
                }
                // error.errorMessage.push(validationObj[0].value[i].message);
            }
            if (validationObj[0].value[i].validationType === "required" && value === validationObj[0].value[i].value) {
                // error.errorMessage.push(validationObj[0].value[i].message);
                error = setValidationMessage(error, validationObj[0].value[i].message);
            }
            if (
                validationObj[0].value[i].validationType === "minLength" &&
                value.length < validationObj[0].value[i].value &&
                value.length !== 0
            ) {
                // error.errorMessage.push(validationObj[0].value[i].message);
                error = setValidationMessage(error, validationObj[0].value[i].message);
            }
            if (
                validationObj[0].value[i].validationType === "maxLength" &&
                value.length > validationObj[0].value[i].value
            ) {
                // error.errorMessage.push(validationObj[0].value[i].message);
                error = setValidationMessage(error, validationObj[0].value[i].message);
            }
            if (validationObj[0].value[i].validationType === "futureDate" && new Date(value) > new Date()) {
                // error.errorMessage.push(validationObj[0].value[i].message);
                error = setValidationMessage(error, validationObj[0].value[i].message);
            }
            
            if (
                validationObj[0].value[i].validationType === "pastDate" &&
                new Date(value) <
                    new Date(today.setDate(today.getDate() - parseInt(validationObj[0].value[i].value) - 1))
            ) {
                // error.errorMessage.push(validationObj[0].value[i].message);
                error = setValidationMessage(error, validationObj[0].value[i].message);
            }
            
            if(
                (new RegExp(`${validationObj[0].value[i].value}`).test(value) && validationObj[0].value[i].validationType === "expression" )
                || (validationObj[0].value[i].validationType === "required" && validationObj[0].value[i].value !== "")
                &&  fieldName == "email"){
                isvalidEmail = true;
                isApicall = false;
            }

            if (validationObj[0].value[i].validationType === "expression" && !new RegExp(`${validationObj[0].value[i].value}`).test(value)) {
                if (
                    checkRequired(validationObj) && (value === "" || !new RegExp(`${validationObj[0].value[i].value}`).test(value))
                ) {
                    // Checking expresssion for email only if its not null
                    if (fieldName === "email") {
                        if (value.trim() !== "") {
                            error = setValidationMessage(error, validationObj[0].value[i].message);
                        }
                    } else {
                        error = setValidationMessage(error, validationObj[0].value[i].message);
                    } 
                } else if (!checkRequired(validationObj) && value !== "") {
                    return {
                        error: !new RegExp(`${validationObj[0].value[i].value}`).test(value),
                        errorMessage: [validationObj[0].value[i].message],
                    };
                }              
                
            }  
                    
           
            } 
                   
         return error;
    } else return error;
};

export const validationCheckemail = async (value, fieldName, family, errorSchema) => {
    let error = { error: false, errorMessage: [] };
 let validationObj =
    errorSchema &&
    errorSchema.length &&
    errorSchema.filter((key) =>
        key.parentDependency ? key.key === fieldName && key.parentDependency === family : key.key === fieldName
    );
    const conditionalValidation =
    validationObj &&
    validationObj[0] &&
    validationObj[0].value.filter((val) => val.validationType === "conditional");
const today = new Date();
if (validationObj && validationObj.length > 0) {
    for (let i = 0; i < validationObj[0].value.length; i++) {
        if ( validationObj[0].value[i].validationType === "required" ) {
            if (fieldName === "email" && value === "") {
                error = setValidationMessage(error, validationObj[0].value[i].message);
            }
        }
        if (validationObj[0].value[i].validationType === "expression" && !new RegExp(`${validationObj[0].value[i].value}`).test(value)) {
            if (checkRequired(validationObj) && (value === "" || !new RegExp(`${validationObj[0].value[i].value}`).test(value))) {
                if (fieldName === "email") {
                    if (value.trim() !== "") {
                        error = setValidationMessage(error, validationObj[0].value[i].message);
                    }
                } else {
                    error = setValidationMessage(error, validationObj[0].value[i].message);
                } 
                // error = setValidationMessage(error, validationObj[0].value[i].message);
            } else if (!checkRequired(validationObj) && value !== "") {
                return {
                    error: !new RegExp(`${validationObj[0].value[i].value}`).test(value),
                    errorMessage: [validationObj[0].value[i].message],
                };
            }
           
            
        }
       
                
        if((
            (new RegExp(`${validationObj[0].value[i].value}`).test(value) && validationObj[0].value[i].validationType === "expression") 
                || (validationObj[0].value[i].validationType === "required" && validationObj[0].value[i].value !== "")
            ) &&  fieldName == "email"
        ){
            isvalidEmail = true;
            isApicall = false;
        }
       
       
        if (validationObj[0].value[i].validationType === "ownerEmailValidation") {
           
            if(value != "" && isvalidEmail && !isApicall){
                isApicall = true;
                let apiData =   await validateOwnerEmail(value)
                    .then((response) => {
                        if(response && response.isvalidEmail){
                            return {
                                error:response.isvalidEmail,
                                errorMessage: [validationObj[0].value[i].message],
                            };
                        }
                         else{
                            return {
                                error:false,
                                errorMessage: [validationObj[0].value[i].message],
                            };
                         }
                        })
                        .catch((apierror) => {
                        return {
                            error:false,
                            errorMessage: [validationObj[0].value[i].message],
                        };
                    });
                 return apiData;
            }
        }
    }
    if(!isApicall)
    return error;
} ;
};

export const validateEmailPDFCanBeSent = async (data,dateOfInstallation,warrantyType,typeofInvoke) => {

    let dateObj = new Date();
    let  month = String(dateObj.getMonth()+1).padStart(2, '0');
    let  day = String(dateObj.getDate()).padStart(2, '0');
    let  year = dateObj.getFullYear();
    let  currentDate = month  + '/'+ day  + '/' + year;
     
    let buildingAddress = {};
    let steepSlopeSq = 0;
    let lowSlopeSquares = 0;
     let  warrantyCode = false;
    let residentialWarrantyFormExist = data.warrantyData && data.warrantyData.residentialWarrantyForm;
    let buildingAndOwnerInfoExist = residentialWarrantyFormExist && data.warrantyData.residentialWarrantyForm.buildingAndOwnerInfo;
    let projectDetailsExist = residentialWarrantyFormExist && data.warrantyInfo.residentialWarrantyForm.projectDetails;
    let emailExist = false;
    
    if( buildingAndOwnerInfoExist ) {
        buildingAddress =data.warrantyData.residentialWarrantyForm.buildingAndOwnerInfo.buildingAddress;
        let emailIdValue= data.warrantyData.residentialWarrantyForm.buildingAndOwnerInfo.ownerInfo.contactPerson.email ; // Exist or not
        emailExist = !!emailIdValue;
    }
    
    
    if( projectDetailsExist ) {
        const projectDetails = data.warrantyInfo.residentialWarrantyForm.projectDetails;
      
        if(!dateOfInstallation) {
            dateOfInstallation =projectDetails.dateOfInstallation;
        }
        steepSlopeSq = Number(projectDetails.steepSlopeSq);
       if(!warrantyType) {
        warrantyCode= projectDetails.warrantyType;
       }        

        if(projectDetails.addendums && projectDetails.addendums.LowSlopeContainer) {
            lowSlopeSquares = projectDetails.addendums.LowSlopeContainer.lowSlopeSquares;
        }       

    }

    if(!dateOfInstallation) { 
        dateOfInstallation = currentDate;
    }
   
   
    if(!warrantyCode || !emailExist) { // if no email exist don't call API
        return false;
    }
    

    let  dataObj = {
        buildingAddress,dateOfInstallation,lowSlopeSquares,steepSlopeSq,warrantyCode
    }
    if(dataObj && dataObj.dateOfInstallation && typeofInvoke !=="mount"){
        var dateIso = new Date (dataObj.dateOfInstallation);   
        dataObj.dateOfInstallation =  dateIso.toISOString();
    }
    let dataString  = JSON.stringify(dataObj);
    try {
        const accessToken = GafOktaManager.storage.info.accessToken;
     let url = API["CONFIG"].baseUrl + "Warranty/EmailPDFCanBeSent";  
     const state = store.getState();
     const TrackingId = AppTracking.id;
     const persistData = getPersistData();
     const contractorId = decodeURIComponent(getQueryString("contractorId", url) ||
     (state.adminData.contractorSelection && state.adminData.contractorSelection.contractorId) ||
     (persistData && persistData.contractorId) ||
     (config && config["contractorId"]));
     const customerId = decodeURIComponent(getQueryString("customerID", url) || getCustomerIDFromStore(false));
     const isAdmin = (state.adminData.userInfo && state.adminData.userInfo.isAdmin) || false;
     const isTm = (state.adminData.userInfo && state.adminData.userInfo.isTm) || false;

     if (contractorId && (isAdmin || isTm)){
        const result = await fetch(url, {
            method: 'post',
            body: dataString,         
           headers: new Headers({
             'Authorization': `Bearer ${accessToken}`,
             'contractorId': `${contractorId}`,
             'trackingid': `${TrackingId}`,
             'Access-Control-Allow-Origin': '*',
             'Access-Control-Allow-Headers' : '*',
                "Content-Type": "application/json",
                "Accept": "application/json"
             
             
            }),
         });
         if(result.ok){
            const resultJson = await result.json();
             return resultJson
            }
     }
     if (customerId && !isAdmin && !isTm){
        const result = await fetch(url, {
            method: 'post',
            body: dataString, 
           headers: new Headers({
             'Authorization': `Bearer ${accessToken}`,
             'customerid': `${customerId}`,
             'trackingid': `${TrackingId}`,
             'Access-Control-Allow-Origin': '*',
             'Access-Control-Allow-Headers' : '*',
             "Content-Type": "application/json",
             "Accept": "application/json"
             
            }),
         });
         if(result.ok){
            const resultJson = await result.json();
             return resultJson
            }
     }
      
    } catch (e) {  
     console.log(" error ", e)
     return false;
    }
  };